import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import ProjectSearch from '../components/ProjectSearch.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        let findBackground = this.el.dataset.background;
        let findQuery = this.el.dataset.query;

        const app = createApp({
            template: '<ProjectSearch background="'+findBackground+'" query="'+findQuery+'" />',
            components: {
                ProjectSearch
            },
            data() {
                return {
                }
            },
            mounted() {
            },
        })
        app.mount(self.el)
    }
}